import { ButtonPrimary } from 'components/Button'
import { AutoColumn } from 'components/Column'
import IntroCard from 'components/IntroCard'
import { RowBetween } from 'components/Row'
import { useActiveWeb3React } from 'hooks'
import React, { useContext } from 'react'
import { useWalletModalToggle } from 'state/application/hooks'
import styled, { ThemeContext } from 'styled-components'
import { TYPE } from 'theme'
import STHYPEPoolCard from './stHYPEPoolCard'
import HypePoolCard from './HypePoolCard'
import { Helmet } from 'react-helmet'

const ContainerStyled = styled.div`
  width: 100%;
  max-width: 870px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 200px;
  padding: 10px;
`

const GridStyled = styled.div`
  display: grid;
  gap: 18px;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

const ConnectWalletContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  min-height: 25vh;
  background: ${({ theme }) => theme.bg0};
  padding: 8px;
  border-radius: 14px;
  width: 100%;

  div {
    max-width: 300px;
  }
`
const TitleRow = styled(RowBetween)`
  color: ${({ theme }) => theme.text2};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
    flex-direction: column-reverse;
  `};
`

const MainContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.bg0};
  padding: 18px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
`

const LiquidityHub = () => {
  const { account } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const theme = useContext(ThemeContext)

  return (
    <>
      <Helmet>
        <title>Liquidity Hub | HyperSwap Exchange on Hyperliquid</title>
        <meta
          name="description"
          content="Explore our ecosystem partners and their contributions to liquidity. Discover collaboration opportunities within the Hyperliquid blockchain."
        />
        <meta
          name="keywords"
          content="HyperSwap liquidity hub, ecosystem partners, Hyperliquid blockchain, DeFi ecosystem, liquidity management"
        />
        <meta property="og:title" content="Liquidity Hub | HyperSwap Exchange on Hyperliquid" />
        <meta
          property="og:description"
          content="Learn more about our ecosystem partners and their role in providing liquidity across Hyperliquid."
        />
        <meta property="og:url" content={`${window.location.origin}/#/liquidity-hub`} />
      </Helmet>
      <ContainerStyled>
        <IntroCard variant={3} Key="Liquidity-hub">
          <h1>Liquidity Hub</h1>
          <p>Our partners within the HyperEVM ecosystem.</p>
        </IntroCard>

        <AutoColumn gap="lg" justify="center">
          <AutoColumn gap="lg" style={{ width: '100%' }}>
            <TitleRow style={{ marginTop: '1rem' }} padding={'0'}>
              <TYPE.mediumHeader>{'Liquidity Hub Overview'}</TYPE.mediumHeader>
            </TitleRow>
            {!account ? (
              <ConnectWalletContainer>
                <div>
                  <TYPE.mediumHeader textAlign="center" color={theme.text3}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-droplets"
                      style={{ marginBottom: '.5rem' }}
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M4.072 20.3a2.999 2.999 0 0 0 3.856 0a3.002 3.002 0 0 0 .67 -3.798l-2.095 -3.227a.6 .6 0 0 0 -1.005 0l-2.098 3.227a3.003 3.003 0 0 0 .671 3.798z" />
                      <path d="M16.072 20.3a2.999 2.999 0 0 0 3.856 0a3.002 3.002 0 0 0 .67 -3.798l-2.095 -3.227a.6 .6 0 0 0 -1.005 0l-2.098 3.227a3.003 3.003 0 0 0 .671 3.798z" />
                      <path d="M10.072 10.3a2.999 2.999 0 0 0 3.856 0a3.002 3.002 0 0 0 .67 -3.798l-2.095 -3.227a.6 .6 0 0 0 -1.005 0l-2.098 3.227a3.003 3.003 0 0 0 .671 3.798z" />
                    </svg>

                    <div>{'Connect your wallet to see the liquidity hub.'}</div>
                  </TYPE.mediumHeader>
                  <ButtonPrimary style={{ marginTop: '2em', padding: '8px 16px' }} onClick={toggleWalletModal}>
                    Connect a wallet
                  </ButtonPrimary>
                </div>
              </ConnectWalletContainer>
            ) : (
              <MainContentWrapper>
                <GridStyled>
                  <STHYPEPoolCard />
                  <HypePoolCard />
                </GridStyled>
              </MainContentWrapper>
            )}
          </AutoColumn>
        </AutoColumn>
      </ContainerStyled>
    </>
  )
}
export default LiquidityHub
